import React from 'react';
import { useSerialized } from '@shopify/react-html';

function createUniversalProvider(id, Context) {
  const UniversalProvider = /*#__PURE__*/React.memo(({
    value: explicitValue,
    children
  }) => {
    const [value = explicitValue, Serialize] = useSerialized(id);

    if (value == null) {
      throw new Error(`You must provide a ${id} value, or have one previously serialized.`);
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Context.Provider, {
      value: value
    }, children), /*#__PURE__*/React.createElement(Serialize, {
      data: () => value
    }));
  });
  const prefix = `${id.charAt(0).toUpperCase()}${id.slice(1).toLowerCase()}`;
  UniversalProvider.displayName = `${prefix}UniversalProvider`;
  return UniversalProvider;
}

export { createUniversalProvider };
